import actions from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-confirmation/actions';
export default () => ({
    state: {
        heading: 'Warehouse Retaliation Complaint Results',
        isLoading: true,
        displayErrors: false,
        data: '',
        formApi: '',
        placeholder: '---',
    },
    actions: {
        ...actions,
    },
});